import React from "react";
import { CircleCheck as CheckCircle2 } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
const facts = [{
  id: 1,
  text: "30 % av den berättigade arbetskostnaden"
}, {
  id: 2,
  text: "Upp till 50 000 kr i ROT-avdrag per person och år"
}, {
  id: 3,
  text: "Material ger inte rätt till ROT-avdrag"
}];
export default function Rotdeduction() {
  return <section id="rotdeduction" data-nav="light" className="bg-background text-foreground py-14 lg:py-20 border-b border-border/50">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column: Information */}
          <div className="flex flex-col gap-4">
            <div>
              <Badge variant="secondary" className="inline-flex items-center justify-center w-fit whitespace-nowrap shrink-0 px-3.5 py-1 text-xs font-medium tracking-wide uppercase rounded-full border border-border bg-secondary text-secondary-foreground">
                ROT-avdrag
              </Badge>
            </div>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-foreground">
              ROT-avdrag vid badrumsrenovering
            </h2>

            <p className="text-muted-foreground text-base sm:text-lg leading-relaxed mt-1">När du renoverar badrummet kan du ha rätt till ROT-avdrag för delar av arbetskostnaden. ROT-avdraget gäller arbete som omfattas av Skatteverkets regler, medan exempelvis material, resor och andra kostnader inte ger rätt till avdrag. Vi hjälper dig att hantera ROT-avdraget på fakturan när villkoren är uppfyllda.</p>
          </div>

          {/* Right Column: Fact Box */}
          <div>
            <div className="bg-card text-card-foreground border border-border rounded-lg shadow-xs p-6 sm:p-8 transition-shadow duration-300 hover:shadow-md">
              <h3 className="text-xl sm:text-2xl font-semibold tracking-tight text-card-foreground mb-6">
                ROT-avdrag 2026
              </h3>

              <ul className="space-y-4 mb-6">
                {facts.map((fact, i) => <li key={fact.id} data-index={i} className="flex items-start gap-3">
                    <CheckCircle2 className="size-5 text-primary shrink-0 mt-0.5" />
                    <span className="text-sm sm:text-base font-medium text-foreground">
                      {fact.text}
                    </span>
                  </li>)}
              </ul>

              <div className="pt-5 border-t border-border/80">
                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  Hur stort avdrag du kan få beror på bland annat din
                  skattesituation och hur mycket ROT- och RUT-avdrag du redan har
                  använt under året.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}